import React, { useRef, useEffect, useState } from 'react';
import classes from './Carousel.module.scss';
import globalJson from 'data/content.json';
import { getFileName } from 'helpers/FileCaching';
import TinySlider from "tiny-slider-react";
import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";
import { TweenMax, Power3} from 'gsap';

const carouselImages = require.context('assets/images/Carousel', true, /.*\.(gif|png|jpe?g|svg)$/i);
const iconsImages = require.context('assets/images/global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);

const Carousel = () => {

    let container = useRef();
    let title = useRef([]);
    let slide = useRef([]);
    let slideImg = useRef([]);
    let slideContent = useRef([]);
    let slideArrow = useRef();

    //Configure scroll magic
    let scrollMagicController = useRef()
    let scrollMagicScene = useRef()

    let showAll_tl = useRef(new TimelineMax({paused:true}));
    showAll_tl.current.timeScale(1);

    ///slide setting
    const settings = {
        container: "#animation1",
        lazyload: true,
        nav: true, 
        navPosition: 'bottom',
        mouseDrag: true,
        loop:false,
        animateIn: "jello",
        animateOut: "rollOut",
        controlsContainer: "#customize-controls",
        speed: 600,
        gutter: 10
      };

    const goToArticle = (url) => {
        window.open(
            url,
            '_blank' 
          );
    }

    // hover effect arrow btn
    const on = (e) =>{
        TweenMax.fromTo(e.target, 0.3, {scale:1, backgroundColor:"#FF7C00", border:"1px solid #FF7C00" }, { delay: 0, scale:1.1,  backgroundColor:"#FF7C00", border:"1px solid #FF7C00",  ease: Power3.easeInOut});
    }
    const off = (e) =>{
         TweenMax.to(e.target, 0.3, {scale:1,  backgroundColor:"#FF7C00", border:"1px solid #FF7C00", ease: Power3.easeInOut})
    }
 

    ///arrow btn animate on hover other elements
    function overPromo(index){
        
        TweenMax.fromTo('.AA-'+ index, 0.2, {scale:1}, { delay: 0, scale:0.7, ease: Power3.easeInOut});
        TweenMax.fromTo( '.BB-'+ index, 0.2, {css:{height:0, width: 0}}, { delay: 0, css:{height:30, width: 30}, ease: Power3.easeInOut});
    }
    function outPromo(index){
        TweenMax.to('.AA-'+ index, 0.2, {scale:1, ease: Power3.easeInOut})
        TweenMax.to('.BB-'+ index, 0.2, {css:{height:0, width: 0}, ease: Power3.easeInOut})
    }


    const onCarouselClick = (title)=>{
        window.gtag('event', "Carousel slide clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': title+ " carousel slide clicked",
			'value':10
          });

    }

    const onPrevArrowClick = (event)=>{
        window.gtag('event', "Carousel prev", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': "Carousel prev clicked",
			'value':10
          });

    }

    const onNextArrowClick = (event)=>{
        window.gtag('event', "Carousel next", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': "Carousel next clicked",
			'value':10
          });

        
    }

    useEffect(() => {
        const configureScrollMagic = () => {

            //Configure scroll magic
            scrollMagicController.current = new ScrollMagic.Controller()
            scrollMagicScene.current = new ScrollMagic.Scene({
                                            triggerHook:0.7
                                        }).addTo(scrollMagicController.current)

            scrollMagicScene.current.triggerElement(container.current);
            // scrollMagicScene.current.duration((container.current.clientHeight));
            scrollMagicScene.current.triggerHook(0.7);
            scrollMagicScene.current.reverse(false);
            scrollMagicScene.current.on("progress", function(event){
                updateTimeline(event.progress);
            })
        }

        configureScrollMagic();
    }, []);
    useEffect(() => {
        const createTimeline = () => {
            
            showAll_tl.current.fromTo(container.current, 1, {delay: -3, opacity:0, y:90},{opacity:1, y:0, ease: Power3.easeInOut}); 
            showAll_tl.current.fromTo([slideImg.current, slideContent.current], 0.6, {delay: - 0.5, opacity:0, y: 60},{opacity:1, y:0, ease: Power3.easeInOut}, 1.6); 
            showAll_tl.current.fromTo([ slideArrow.current, ".tns-nav"], 1, {delay: 0, opacity:0},{opacity:1, ease: Power3.easeInOut}, 1); 
        }

        createTimeline();
    }, []);
    
    const updateTimeline = (progress) => {
        let timelineLength = showAll_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        showAll_tl.current.tweenTo(tweenToSeconds);
    }

    return(
        <div className={classes.Carousel}>
            <div ref={container} className={`${classes.Carousel__container}`}>
                <div className={`row ${classes.Carousel__row}`}>
                    <h5 ref={title} className={`col-md-12 section_title ${classes.Carousel__title}`}>{globalJson.carousel.title}</h5>
                </div>
                <div className={`row ${classes.Carousel__row}`}> 
                    <div ref={slideArrow} className="controls " id="customize-controls" aria-label="Carousel Navigation" tabIndex="0">
                            <button className={`prevCarousel ${classes.Carousel__prevArrow}`} data-controls="prev" aria-controls="customize" tabIndex="-1" onClick={(event) =>{onPrevArrowClick(event)}}>
                                <img alt="prev arrow" src={getFileName(iconsImages, 'backArrowCarousel.svg')} onMouseOver={on} onMouseOut={off} />
                            </button>
                            <button className={`nextCarousel ${classes.Carousel__nextArrow}`} data-controls="next" aria-controls="customize" tabIndex="-1" onClick={(event) =>{onNextArrowClick(event)}}>
                                <img  alt="next arrow" src={getFileName(iconsImages, 'nextArrowCarousel.svg')}  onMouseOver={on} onMouseOut={off} />
                            </button>
                    </div>
              
                    <TinySlider settings={settings} >
                        {globalJson.carousel.slides.map((el, index) => (
                            <div ref={el => slide.current[index] = el} key={index} className={classes.Carousel__slide} >
                                <div className={`row ${classes.Carousel__rowSlide}`}>
                                    <div className={`col-md-12 col-lg-9 col-xl-7 ${classes.Carousel__imgContainer}`}>
                                            <div ref={el => slideImg.current[index] = el} className={`${classes.Carousel__image}`}
                                            style={
                                                {
                                                    backgroundImage: 'url(' + getFileName(carouselImages, el.image) + ')'
                                                }
                                            }
                                            onMouseOver={() => overPromo(index)} onMouseOut={() => outPromo(index)}
                                            onClick={(event) =>{onCarouselClick(el.title); goToArticle(el.url);}} >
                                        </div>
                                    </div>
                                        <div className={`col-md-10 col-lg-6 ${classes.Carousel__contentWrap}`} onMouseOver={() => overPromo(index)} onMouseOut={() => outPromo(index)} onClick={(event) =>{onCarouselClick(el.title); goToArticle(el.url);}} >
                                            <div ref={el => slideContent.current[index] = el} className={classes.Carousel__content}>
                                                <h5 className={classes.Carousel__contentSubtitle}>{el.subtitle}</h5>
                                                <h3 className={classes.Carousel__contentTitle}>{el.title}</h3>
                                                <p className={`col-md-10 ${classes.Carousel__contentDescription}`}>{el.description}</p>
                                                <div onClick={(event) =>{onCarouselClick(el.title); goToArticle(el.url);}} className={`arrowCta ${classes.DynamicPagePromos__promoCta}`} onMouseOver={() => overPromo(index)} onMouseOut={() => outPromo(index)}>
                                                <div className={`${classes.Carousel__ctaWrapper}`}>
                                                    {el.cta}
                                                    <span className={`arrowCta__iconWrapper`}>
                                                        <span className={`BB-${index} arrowCta__onHover`}></span>
                                                        <img  className={`AA-${index} arrowCta__oval`} alt="play icon border" src={getFileName(iconsImages, 'ovalArrow.svg')}/>
                                                        <img  className={`arrowCta__arrow`} alt="play icon" src={getFileName(iconsImages, 'nextArrow.svg')}/>
                                                    </span>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                </div>
                            
                            </div> 
                            
                        ))} 
                            
                    </TinySlider>
                </div>
            </div>
        </div>
    )
}

export default Carousel;